/**
 * The ring's icons — single-stroke paths on a 24-unit box, drawn with
 * `stroke: currentColor` by the ring. Taken from the prototype's set (QR7) so the
 * product and its spec draw the same marks. Not colours, so not tokens.
 */
export const RING_ICONS = {
  file: "M6 3h8l4 4v14H6z M14 3v4h4 M9 12h6 M9 16h6",
  arrive: "M5 12.5l4.5 4.5L19 7",
  seat: "M7 4v9h9l2 6 M7 13l-1 7 M16 13l1-4h3",
  finish: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M8 12l3 3 5-6",
  tooth:
    "M8 3.5c-2.5 0-4 1.8-4 4.5 0 2.5 1 4.5 1.7 7 .6 2.5 1.2 5 2.3 5s1.6-3 2.2-5.5h3.6c.6 2.5 1.1 5.5 2.2 5.5s1.7-2.5 2.3-5c.7-2.5 1.7-4.5 1.7-7 0-2.7-1.5-4.5-4-4.5-1.9 0-2.6 1-4 1s-2.1-1-4-1z",
  note: "M5 3h14v18H5z M8 8h8 M8 12h8 M8 16h5",
  book: "M4 6h16v14H4z M4 10h16 M8 3v5 M16 3v5 M12 12.5v5 M9.5 15h5",
  xray: "M4 5h16v14H4z M7 16l3.5-4.5 3 3 2-2L19 16",
  pay: "M3 6h18v12H3z M3 10h18 M7 15h3",
  move: "M4 7h16v13H4z M4 11h16 M8 4v5 M16 4v5 M9 15.5h6 M13 13.5l2 2-2 2",
  noshow: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M6 6l12 12",
  cancel: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M9 9l6 6 M15 9l-6 6",
  plus: "M12 5v14 M5 12h14",
  minus: "M5 12h14",
  person: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21c1-4 4-6 8-6s7 2 8 6",
  personplus:
    "M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M3 21c1-4 3.5-6 7-6 1.6 0 3 .4 4.1 1.1 M18 14v6 M15 17h6",
  lock: "M6 11h12v10H6z M8.5 11V8a3.5 3.5 0 0 1 7 0v3",
  list: "M9 6h11 M9 12h11 M9 18h11 M4.5 6h.01 M4.5 12h.01 M4.5 18h.01",
  flag: "M5 21V4 M5 4h11l-2 4 2 4H5",
  image: "M4 5h16v14H4z M8.5 10a1.5 1.5 0 1 0 0-.01 M20 16l-5-5-8 8",
  invoice: "M6 3h12v18l-3-2-3 2-3-2-3 2z M9 8h6 M9 12h6",
  pencil: "M4 20h4L19 9l-4-4L4 16z M13.5 6.5l4 4",
  copy: "M8 8h12v12H8z M16 8V4H4v12h4",
  retire: "M4 7h16 M6 7v13h12V7 M9 4h6 M10 11v6 M14 11v6",
  box: "M4 8l8-4 8 4v8l-8 4-8-4z M4 8l8 4 8-4 M12 12v8",
  open: "M4 8l8-4 8 4 M4 8v8l8 4 8-4V8 M12 12l8-4 M8 6l8 4",
  cart: "M3 4h2l2.5 11h11L21 8H6.3 M9 20h.01 M18 20h.01",
  truck: "M3 6h11v10H3z M14 10h4l3 3v3h-7 M7 19a2 2 0 1 0 0-.01 M17 19a2 2 0 1 0 0-.01",
  gauge: "M4 18a8 8 0 1 1 16 0 M12 18l4-6",
  tag: "M3 12V4h8l10 10-8 8z M7.5 8a.5.5 0 1 0 0-.01",
  check: "M5 12.5l4.5 4.5L19 7",
  hand: "M8 12V5.5a1.5 1.5 0 0 1 3 0V11 M11 10V4.5a1.5 1.5 0 0 1 3 0V11 M14 10.5V6a1.5 1.5 0 0 1 3 0v8a7 7 0 0 1-7 7 6 6 0 0 1-5-3l-2.5-4a1.5 1.5 0 0 1 2.5-1.6L8 14",
  snooze: "M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M12 9v4l2.5 2 M5 3L2 6 M19 3l3 3",
  close: "M6 6l12 12 M18 6L6 18",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1 M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  sick: "M12 3v18 M3 12h18 M7 7l10 10",
  week: "M4 5h16v15H4z M4 9h16 M8 13h2 M12 13h2 M16 13h.01 M8 16.5h2 M12 16.5h2",
  day: "M4 5h16v15H4z M4 9h16 M12 12v5 M9.5 14.5h5",
  undo: "M9 14L4 9l5-5 M4 9h10a6 6 0 0 1 0 12h-3",
  send: "M4 12l16-8-6 16-2-7z M12 13l8-9",
  target: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M12 12h.01",
  folder: "M3 6h6l2 2h10v11H3z",
  upload: "M12 16V4 M7 9l5-5 5 5 M4 16v4h16v-4",
  chair: "M7 4v9h9l2 6 M7 13l-1 7 M16 13l1-4h3",
  money: "M3 6h18v12H3z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  today: "M4 5h16v15H4z M4 9h16 M12 14.5h.01",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l2 2H4z M10 20a2 2 0 0 0 4 0",
  whatsapp: "M4 20l1.4-4A8 8 0 1 1 8 18.6z M9 9.5c0 3 2.5 5.5 5.5 5.5",
} as const;
